module.exports = __webpack_public_path__ + "static/media/sign-in.4f5a0efd.svg";